
export default function DifferencesSection() {
  const differences = [
    {
      icon: 'ri-star-line',
      title: 'Qualité premium',
      description: 'Design sur mesure, contenu professionnel, aucun compromis sur la qualité'
    },
    {
      icon: 'ri-time-line',
      title: 'Livraison en 21 jours',
      description: 'Processus optimisé et équipe dédiée pour respecter les délais'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantie satisfaction',
      description: 'On refait le site si le design ou le contenu ne vous conviennent pas'
    },
    {
      icon: 'ri-team-line',
      title: 'Équipe experte',
      description: 'Designers, rédacteurs et développeurs spécialisés en sites business'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Pourquoi nous choisir ?
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Une approche unique qui combine rapidité, qualité et résultats mesurables
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {differences.map((item, index) => (
            <div 
              key={index}
              className="text-center group"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-yellow-600 to-yellow-700 rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <i className="ri-shield-star-line text-5xl text-yellow-500 mb-6"></i>
            <h3 className="text-3xl font-bold mb-4">Notre garantie</h3>
            <p className="text-xl text-slate-300 leading-relaxed">
              Si le design ou le contenu ne vous conviennent pas, on refait le site. Votre satisfaction est notre priorité absolue.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
